import { connect } from 'react-redux';
import { object, string } from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import Switch from 'yoda-core-components/lib/components/Switch/Switch';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { messagesActions } from 'yoda-site-components/lib/components/Messages';
import MessageBox from 'yoda-core-components/lib/components/MessageBox';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { formErrorAnalytics, pdpEnableVto } from '../../actions/AnalyticsAction';
import { toggleVto, resetVtoMessage } from '../../actions/VirtualTryOnAction';
import { getVirtualTryOnData } from '../../selectors/VirtualTryOnSelector';
import { scrollToFirstMessage } from '../../helpers/AddToHelpers';
import isValidVTO from '../../validation/isValidVTO';
import { VTO_TOGGLE_TEXT } from '../../helpers/VTOConstants';
import * as styles from './VirtualTryOn.css';

const cx = classNames.bind(styles);
export class VirtualTryOnToggle extends Component {
    static defaultProps = {
        messagesTexts: {},
        productOptions: {},
        virtualTryOn: {},
    };

    static propTypes = {
        actions: object.isRequired,
        unsupportedBrowserMessage: string.isRequired,
        messagesTexts: object,
        productOptions: object,
        virtualTryOn: object,
    };

    constructor(props) {
        super(props);
        this.state = {
            isIE11: false,
        };
    }

    componentDidMount() {
        this.setState({ isIE11: !!window.MSInputMethodContext && !!document.documentMode });
    }

    getInfoMessages = (validationResult, isFormValidation) => {
        const { actions } = this.props;
        const formErrors = [];
        /* istanbul ignore else */
        if (validationResult && validationResult.messages && validationResult.messages.length) {
            validationResult.messages.forEach((error) => {
                error.message.type = 'warning';
                actions.addMessage({ ...error, sourceMiniPDP: false });
                const errorMsgTitle = get(error.message, 'title', '').toLowerCase();
                const isDuplicateErrorMsg =
                    formErrors.find((errorMsg) => errorMsg.errorDescription === errorMsgTitle) ||
                    false;
                /* istanbul ignore else */
                if (isFormValidation && !isDuplicateErrorMsg) {
                    formErrors.push({ errorDescription: errorMsgTitle });
                }
            });

            isFormValidation && actions.formErrorAnalytics(formErrors);
        }
    };

    formErrorValidation = (addToCartFormValidationResult) => {
        const isFormValidation = true;
        this.getInfoMessages(addToCartFormValidationResult, isFormValidation);
        setImmediate(scrollToFirstMessage);
    };

    onToggleVTO = () => {
        const toggleEnabled = get(this.props.virtualTryOn, 'data.enabled', false);
        /* istanbul ignore else */
        if (!toggleEnabled) {
            const validation = isValidVTO(
                this.props.productOptions,
                this.props.messagesTexts.ProductOptionsMessages
            );
            /* istanbul ignore else */
            if (validation.invalid) {
                document.activeElement && document.activeElement.blur();
                this.formErrorValidation(validation);
                return;
            }
        }
        !toggleEnabled && this.props.actions.pdpEnableVto();
        this.props.actions.toggleVto({
            enabled: !toggleEnabled,
        });
    };

    removeVtoMessage = () => {
        this.props.actions &&
            this.props.actions.resetVtoMessage &&
            this.props.actions.resetVtoMessage();
    };

    renderUnsupportedBrowserMessage = () => {
        const { isIE11 } = this.state;
        const { unsupportedBrowserMessage } = this.props;

        return isIE11 ? (
            <MessageBox
                className={dt(['mt-4'])}
                message={unsupportedBrowserMessage}
                messageType="info"
                showMessage
            />
        ) : null;
    };

    render() {
        const { isIE11 } = this.state;
        const toggleEnabled = get(this.props.virtualTryOn, 'data.enabled', false);
        const message = toggleEnabled && get(this.props.virtualTryOn, 'data.message');
        const vtoCheckboxConfig = {
            disabled: isIE11,
            checked: toggleEnabled,
            id: 'vtoSwitch',
            name: 'vto-checkbox',
            'data-automation-id': 'vto-switch',
        };
        return (
            <ErrorBoundary>
                {message ? (
                    <div className={dt(['mt-6'])}>
                        <MessageBox
                            messageType={message.type}
                            automationId={message.id}
                            className={[
                                cx('virtualTryOnMessageContainer'),
                                dt(['items-center']),
                            ].join(' ')}
                            message={message.body}
                            showCloseButton
                            showMessage
                            closeHandler={this.removeVtoMessage}
                        />
                    </div>
                ) : null}
                {this.renderUnsupportedBrowserMessage()}
                <div className={dt(['flex', 'mt-4', 'mb-4'])}>
                    <Switch
                        className={dt(['inline-block'])}
                        config={vtoCheckboxConfig}
                        onClick={this.onToggleVTO}
                    />
                    <span
                        className={[
                            cx('virtualTryOnText', { 'text-gray-40': isIE11 }),
                            dt([
                                'font-open-sans-semibold',
                                'mx-3',
                                'text-base',
                                'text-black',
                                'h-6',
                            ]),
                        ].join(' ')}
                    >
                        {VTO_TOGGLE_TEXT}
                    </span>
                </div>
            </ErrorBoundary>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...messagesActions,
            formErrorAnalytics,
            toggleVto,
            resetVtoMessage,
            pdpEnableVto,
        },
        dispatch
    ),
});

const mapStateToProps = (state, ownProps) => ({
    messagesTexts: state.context.messagesTexts,
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
    unsupportedBrowserMessage: get(
        state,
        'context.preferences.revieveConfiguration.unsupportedBrowserMessage',
        'This service is not supported by Internet Explorer. Please use Chrome, Firefox, or Safari.'
    ),
    virtualTryOn: getVirtualTryOnData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualTryOnToggle);
